// import {ListViewProvider, useListView} from '../core/ListViewProvider'
// import {QueryRequestProvider, useQueryRequest} from '../core/QueryRequestProvider'
// import {QueryResponseProvider, useQueryResponseData} from '../core/QueryResponseProvider'
// import {UsersListHeader} from '../components/header/UsersListHeader'
// import {UsersTable} from '../table/UsersTable'
// import {UserEditModal} from '../form-edit-modal/CoomonEditModal'
// import {KTCard, initialQueryState} from '../../../../../../_metronic/helpers'
// import {Card4} from '../../../../../../_metronic/partials/content/cards/Card4'
// import {roleColumns} from './_columns'
// import {useEffect, useState} from 'react'
// import {useQuery} from 'react-query'
// import {getUserById} from '../core/_requests'
// import {useAuth} from '../../../../auth'
// import {useFetchCommon} from '../../../../../../_metronic/helpers/crud-helper/useQuery'

// export const generateYearOptions = (startYear: any) => {
//   const currentYear = new Date().getFullYear()
//   const years: any = []

//   for (let year = currentYear; year >= startYear; year--) {
//     years.push({value: year.toString(), label: `${year}`})
//   }
//   return years
// }

// const UsersList = () => {
//   const {auth, isFacilityManager} = useAuth()
//   const hideDropdown = auth?.data?.userType === 'SMART_CENTRE' || false
//   const {data: datas} = useQuery(
//     `users?page=0&size=10&type=FRANCHISE`,
//     () => getUserById('', 'users?page=0&size=10&type=FRANCHISE'),
//     {
//       enabled: hideDropdown,
//       cacheTime: 0,
//       onError: (err) => {
//         console.warn(err)
//       },
//     }
//   )
//   const {updateState} = useQueryRequest()
//   const [categoriesList, setCategoriesList] = useState([{label: 'Select one', value: ''}])
//   const {responseData: facilityTypeList} = useFetchCommon({
//     api: 'users?page=0&size=10&type=PICKUP_POINT',
//     label: ['personalDetails', 'name'],
//     isDropDown: true,
//     isEnabled: !isFacilityManager,
//   })
//   useEffect(() => {
//     if (datas && datas.length) {
//       let dropdownData: any = [{label: 'Select one', value: ''}]
//       datas.map((eachData) => {
//         return dropdownData.push({label: eachData?.personalDetails?.name, value: eachData.id})
//       })
//       setCategoriesList(dropdownData)
//       updateState({
//         enabled: true,
//         initialApi: `categories/${dropdownData[0]?.value}/items`,
//         ...initialQueryState,
//       })
//     }
//   }, [datas])

//   const options = generateYearOptions(2015)
//   const facilityType = [
//     {value: '', label: 'Select one'},
//     {value: 'COLLECTION', label: 'Material Inward'},
//     {value: 'PRODUCTION', label: 'Production'},
//     {value: 'DISPATCH', label: 'Sales'},
//   ]
//   /* COLLECT PROCESS DISPATCH */

//   const searchElements = [
//     {
//       type: 'select',
//       value: 'select',
//       options: options,
//       name: 'start_date',
//       label: 'Year',
//     },
//     {
//       type: 'select',
//       value: 'select',
//       options: facilityType,
//       name: 'status',
//       label: 'Type',
//     },
//     {
//       type: 'select',
//       value: 'select',
//       // options: facilityTypeList,
//       // options: [{value: '', label: 'Select one'}, ...facilityTypeList],
//       options: [
//         {value: '', label: 'Select one'},
//         ...(isFacilityManager
//           ? [{value: auth?.data?.pickuppointid, label: auth?.data?.pickuppointName}]
//           : facilityTypeList),
//       ],
//       name: 'franchiseeid',
//       label: 'Facility',
//     },
//   ]
//   const data: any = useQueryResponseData()
//   return (
//     <KTCard>
//       <UsersListHeader
//         showDownload
//         showResetButton={true}
//         initialApi='collect/orders'
//         searchElements={searchElements}
//         placeholder='Search Category'
//       />
//       <UsersTable
//         mockedData={data?.monthlyDetails || []}
//         initialApi='collect/orders'
//         showPagination={true}
//         columnProps={roleColumns}
//       />
//       {data?.monthlySupplierDetails?.map((x, index) => (
//         <div key={index + 1 + ''}>
//           <div className='ml-9'>{x?.supplierName || ''}</div>
//           <UsersTable
//             mockedData={x?.itemWiseSupply || []}
//             initialApi='collect/orders'
//             showPagination={true}
//             columnProps={roleColumns}
//           />
//         </div>
//       )) ?? ''}
//       <UserEditModal showViewPage getByIdApi='collect/orders/' formName='CollectOrdersModalForm' />
//     </KTCard>
//   )
// }

// const InvenotryListsWrapper = () => (
//   <QueryRequestProvider initialValue={{enabled: false}}>
//     <QueryResponseProvider>
//       <ListViewProvider>
//         <UsersList />
//       </ListViewProvider>
//     </QueryResponseProvider>
//   </QueryRequestProvider>
// )

// export {InvenotryListsWrapper}






import { ListViewProvider, useListView } from '../core/ListViewProvider'
import { QueryRequestProvider, useQueryRequest } from '../core/QueryRequestProvider'
import { QueryResponseProvider, useQueryResponseData } from '../core/QueryResponseProvider'
import { UsersListHeader } from '../components/header/UsersListHeader'
import { UsersTable } from '../table/UsersTable'
import { UserEditModal } from '../form-edit-modal/CoomonEditModal'
import { KTCard, initialQueryState } from '../../../../../../_metronic/helpers'
import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
import { roleColumns } from './_columns'
import { useEffect, useState, useMemo } from 'react'
import { useQuery } from 'react-query'
import { getUserById } from '../core/_requests'
import { useAuth } from '../../../../auth'
import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery'
import ExcelJS from 'exceljs'

export const generateYearOptions = (startYear: any) => {
  const currentYear = new Date().getFullYear()
  const years: any = []

  for (let year = currentYear; year >= startYear; year--) {
    years.push({ value: year.toString(), label: `${year}` })
  }
  return years
}

const UsersList = () => {
  const { auth, isFacilityManager } = useAuth()
  const hideDropdown = auth?.data?.userType === 'SMART_CENTRE' || false
  const { data: datas } = useQuery(
    `users?page=0&size=10&type=FRANCHISE`,
    () => getUserById('', 'users?page=0&size=10&type=FRANCHISE'),
    {
      enabled: hideDropdown,
      cacheTime: 0,
      onError: (err) => {
        console.warn(err)
      },
    }
  )
  const { updateState } = useQueryRequest()
  const [categoriesList, setCategoriesList] = useState([{ label: 'Select one', value: '' }])
  const { responseData: facilityTypeList } = useFetchCommon({
    api: 'users?page=0&size=10&type=PICKUP_POINT',
    label: ['personalDetails', 'name'],
    isDropDown: true,
    isEnabled: !isFacilityManager,
  })
  useEffect(() => {
    if (datas && datas.length) {
      let dropdownData: any = [{ label: 'Select one', value: '' }]
      datas.map((eachData) => {
        return dropdownData.push({ label: eachData?.personalDetails?.name, value: eachData.id })
      })
      setCategoriesList(dropdownData)
      updateState({
        enabled: true,
        initialApi: `categories/${dropdownData[0]?.value}/items`,
        ...initialQueryState,
      })
    }
  }, [datas])

  const options = generateYearOptions(2015)
  const facilityType = [
    { value: '', label: 'Select one' },
    { value: 'COLLECTION', label: 'Material Inward' },
    { value: 'PRODUCTION', label: 'Production' },
    { value: 'DISPATCH', label: 'Sales' },
  ]

  const searchElements = [
    {
      type: 'select',
      value: 'select',
      options: options,
      name: 'start_date',
      label: 'Year',
    },
    {
      type: 'select',
      value: 'select',
      options: facilityType,
      name: 'status',
      label: 'Type',
    },
    {
      type: 'select',
      value: 'select',
      options: [
        { value: '', label: 'Select one' },
        ...(isFacilityManager
          ? [{ value: auth?.data?.pickuppointid, label: auth?.data?.pickuppointName }]
          : facilityTypeList),
      ],
      name: 'franchiseeid',
      label: 'Material Hub',
    },
  ]

  const data: any = useQueryResponseData()

  // Create a single combined dataset for download
  const combinedDataForExcel = useMemo(() => {
    const combined: any[] = []

    // Add main monthly details with section identifier
    if (data?.monthlyDetails?.length > 0) {
      combined.push(...data.monthlyDetails.map((item: any) => ({
        ...item,
        section: 'Monthly Details',
        supplierName: 'Main Data'
      })))
    }

    // Add supplier data with supplier names
    if (data?.monthlySupplierDetails?.length > 0) {
      data.monthlySupplierDetails.forEach((supplier: any) => {
        if (supplier.itemWiseSupply?.length > 0) {
          combined.push(...supplier.itemWiseSupply.map((item: any) => ({
            ...item,
            section: 'Supplier Data',
            supplierName: supplier.supplierName
          })))
        }
      })
    }

    return combined
  }, [data])

  // Override the response data for download
  useEffect(() => {
    if (combinedDataForExcel.length > 0 && data) {
      data.data = combinedDataForExcel
    }
  }, [combinedDataForExcel, data])

  // Individual table download function
  const downloadSingleTable = async (tableData: any[], fileName: string) => {
    if (!tableData || tableData.length === 0) {
      alert('No data to download')
      return
    }

    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet('Sheet1')

    // Define headers exactly as you specified
    const headers = [
      { header: 'S.N', key: 'sn', width: 10 },
      { header: 'CATEGORY', key: 'categoryName', width: 20 },
      { header: 'ITEM', key: 'itemName', width: 20 },
      { header: 'JAN', key: 'jan', width: 15 },
      { header: 'FEB', key: 'feb', width: 15 },
      { header: 'MARCH', key: 'march', width: 15 },
      { header: 'APRIL', key: 'april', width: 15 },
      { header: 'MAY', key: 'may', width: 15 },
      { header: 'JUNE', key: 'june', width: 15 },
      { header: 'JULY', key: 'july', width: 15 },
      { header: 'AUG', key: 'aug', width: 15 },
      { header: 'SEP', key: 'sep', width: 15 },
      { header: 'OCT', key: 'oct', width: 15 },
      { header: 'NOV', key: 'nov', width: 15 },
      { header: 'DEC', key: 'dec', width: 15 }
    ]

    worksheet.columns = headers

    // Transform data to match the required format
    const transformedData = tableData.map((item, index) => {
      const monthData = item.monthWiseData || {}

      return {
        sn: index + 1,
        categoryName: item.categoryName || '',
        itemName: item.itemName || '',
        jan: monthData['2025-01'] || 0,
        feb: monthData['2025-02'] || 0,
        march: monthData['2025-03'] || 0,
        april: monthData['2025-04'] || 0,
        may: monthData['2025-05'] || 0,
        june: monthData['2025-06'] || 0,
        july: monthData['2025-07'] || 0,
        aug: monthData['2025-08'] || 0,
        sep: monthData['2025-09'] || 0,
        oct: monthData['2025-10'] || 0,
        nov: monthData['2025-11'] || 0,
        dec: monthData['2025-12'] || 0
      }
    })

    // Add the transformed data
    transformedData.forEach(row => {
      worksheet.addRow(row)
    })

    // Style the headers
    worksheet.getRow(1).font = { bold: true }
    worksheet.getRow(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE0E0E0' }
    }

    const buffer = await workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `${fileName}.xlsx`
    link.click()
    window.URL.revokeObjectURL(url)
  }

  const monthlyDetails = Array.isArray(data?.monthlyDetails) ? data.monthlyDetails : []

  return (
    <KTCard>
      <UsersListHeader
        // showDownload
        showResetButton={true}
        initialApi='collect/orders'
        searchElements={searchElements}
        placeholder='Search Category'
      />

      {/* Main Monthly Details Table with its own download */}
      {monthlyDetails.length > 0 ? (
        <div>
          <div className="d-flex justify-content-between align-items-center mb-3 px-3">
            <h5 className="mb-0">Monthly Details</h5>
            <button
              className="btn btn-sm btn-primary"
              onClick={() => downloadSingleTable(monthlyDetails, 'monthly-details')}
            >
              Download Monthly Details
            </button>
          </div>
          <UsersTable
            mockedData={monthlyDetails}
            initialApi='collect/orders'
            showPagination={true}
            columnProps={roleColumns}
          />
        </div>
      ) : (
        <div className="text-center p-4">No monthly details available</div>
      )}

      {/* Supplier Tables with individual download buttons */}
      {Array.isArray(data?.monthlySupplierDetails) && data.monthlySupplierDetails.length > 0 &&
        data.monthlySupplierDetails.map((x: any, index: number) => (
          <div key={index + 1 + ''} className="mt-5">
            <div className="d-flex justify-content-between align-items-center mb-3 px-3">
              <h6 className='mb-0 font-weight-bold'>{x?.supplierName || `Supplier ${index + 1}`}</h6>
              <button
                className="btn btn-sm btn-secondary"
                onClick={() => downloadSingleTable(x.itemWiseSupply, `supplier-${x.supplierName || index}`)}
                disabled={!x.itemWiseSupply || x.itemWiseSupply.length === 0}
              >
                Download {x?.supplierName || `Supplier ${index + 1}`}
              </button>
            </div>
            {Array.isArray(x?.itemWiseSupply) && x.itemWiseSupply.length > 0 ? (
              <UsersTable
                mockedData={x.itemWiseSupply}
                initialApi='collect/orders'
                showPagination={true}
                columnProps={roleColumns}
              />
            ) : (
              <div className="text-center p-4 text-dark">No data available for this supplier</div>
            )}
          </div>
        ))
      }

      <UserEditModal showViewPage getByIdApi='collect/orders/' formName='CollectOrdersModalForm' />
    </KTCard>
  )
}

const InvenotryListsWrapper = () => (
  <QueryRequestProvider initialValue={{ enabled: false }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <UsersList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { InvenotryListsWrapper }